import React from "react";
import SendIcon from "@material-ui/icons/Send";

export default class ItemButtonCustom extends React.Component {
  render() {
    const {id, action} = this.props;
    const Icon = action.icon || SendIcon;
    // hidden оставляет пустое место той же ширины: блок кнопок у всех строк
    // одной ширины, иначе колонки таблицы в этой строке съезжают
    const hidden = action.hidden && action.hidden(id);
    return (
      <div title={hidden ? undefined : action.label} style={{ width: 20, marginLeft: 10 }}>
        {!hidden && <Icon
          width="15"
          height="15"
          onClick={(e) => action.action(id)}
        />}
      </div>
    );
  }
}
